/**
 * Traduit l'erreur de `admit_visio_participant` (`packages/db/migrations/0259`)
 * en message ACTIONNABLE pour l'hôte — le bug d'origine : un message générique
 * masquait `room_full` (capacité de la salle atteinte), l'hôte cliquait
 * « Admettre » en boucle sans comprendre pourquoi ça échouait, et l'invité
 * restait bloqué en salle d'attente indéfiniment. `room_full` pointe
 * explicitement vers le réglage qui débloque la situation (« Réglages » →
 * nombre de participants max, `RoomSettingsPanel`).
 */
export function translateAdmitError(message: string, displayName: string): string {
  const name = displayName || 'ce participant';
  if (message.includes('room_full')) {
    return `Salle pleine : augmente le nombre de participants dans Réglages pour admettre ${name}.`;
  }
  if (message.includes('not_authorized')) {
    return "Tu n'es plus autorisé à gérer cette salle.";
  }
  if (message.includes('not_waiting')) {
    return `${name} n'est plus en salle d'attente (déjà admis·e, refusé·e ou reparti·e).`;
  }
  return `Impossible d'admettre ${name}. Réessaie.`;
}
